import {Feature as FeatureType} from 'puffco-api-axios-client';

export enum Feature {
  Rehash = 'rehash',
  Referral = 'referral',
}

export const config: Record<string, FeatureType> = {};
